import { tours } from '../data/tours';
import { buildSiteUrl, localizePath } from './localizedRoutes';

function slugify(value = '') {
  return String(value)
    .toLowerCase()
    .trim()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');
}

export function getTourSlug(tour) {
  if (!tour) return '';
  return tour.slug || slugify(tour.name);
}

export function getTourPath(tour, language = 'en') {
  if (tour?.customPath) return localizePath(tour.customPath, language);
  return localizePath(`/tours/${getTourSlug(tour)}`, language);
}

export function getTourUrl(tour, language = 'en') {
  if (tour?.customPath) return buildSiteUrl(tour.customPath, language);
  return buildSiteUrl(`/tours/${getTourSlug(tour)}`, language);
}

export function findTourByIdentifier(identifier) {
  const normalizedIdentifier = String(identifier || '').trim().toLowerCase();

  if (!normalizedIdentifier) return null;

  return tours.find((tour) => (
    String(tour.id) === normalizedIdentifier
    || getTourSlug(tour) === normalizedIdentifier
  )) || null;
}
